import { UseMutationOptions, useQueryClient } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import {
  UpdateLeadSubscriptionMutation,
  UpdateLeadSubscriptionMutationVariables,
} from "lib/generated/app-service-gql/graphql";
import { useGraphQlMutation } from "../useGraphQlClient";
import { upsertCompanyLeadSubscription } from "./leadSubscriptionCache";

const updateLeadSubscriptionMutation = graphql(`
  mutation updateLeadSubscription($input: UpdateLeadSubscriptionRequest!) {
    updateLeadSubscription(UpdateLeadSubscriptionRequest: $input) {
      id
      destinationSettings {
        type
        name
        webhookUrl
      }
      frequency
      disabled
      pausedByRefusals
      views {
        id
        name
        description
        dataType
        contentId
      }
    }
  }
`);

export function useUpdateLeadSubscription(
  options?: UseMutationOptions<
    UpdateLeadSubscriptionMutation,
    unknown,
    UpdateLeadSubscriptionMutationVariables,
    unknown
  >,
) {
  const queryClient = useQueryClient();
  const { data, ...rest } = useGraphQlMutation(updateLeadSubscriptionMutation, {
    ...options,
    onSuccess: (data, variables, context) => {
      upsertCompanyLeadSubscription(queryClient, data.updateLeadSubscription);
      options?.onSuccess && options?.onSuccess(data, variables, context);
    },
  });
  return { data: data?.updateLeadSubscription, ...rest };
}
